export default __webpack_public_path__ + "static/media/Footer2_black_en.c64bcb67.png";